import { formYESNO } from '@/helpers/constants';

export const VEHICLESOK_DATA = {
  dates: {
    key: 'dates',
    value: 'Date',
    chipProps: {
      show: true,
      label: 'VehicleCleanDirt.dates',
    },
    calendarProps: {
      show: true,
      id: 'date-picker-VehicleCleanDirt-',
      label: 'VehicleCleanDirt.dates',
    },
    inputProps: {
      show: true,
      id: 'VehicleCleanDirt-dates-textDate',
      key: 'VehicleCleanDirt-dates-textDate',
      label: 'VehicleCleanDirt.dateReference',
      charLimit: 40,
    },
    inputPropsTime: {
      show: true,
      id: 'VehicleCleanDirt-time-timeDate',
      key: 'VehicleCleanDirt-time-timeDate',
      label: 'VehicleCleanDirt.time',
      type: 'time',
    },
    additionalInputProps: {
      show: false,
    },
    drowpdownProps: {
      show: false,
    },
  },
  ttzs: {
    key: 'ttzs',
    value: 'TTZ',
    chipProps: {
      show: true,
      label: 'VehicleCleanDirt.ttzs',
    },
    calendarProps: {
      show: true,
      id: 'date-picker-VehicleCleanDirt-',
      label: 'VehicleCleanDirt.ttzs',
    },
    inputProps: {
      show: false,
    },
    inputPropsTime: {
      show: false,
    },
    additionalInputProps: {
      show: false,
    },
    drowpdownProps: {
      show: false,
    },
  },
  vehicleIdentificationNumbers: {
    key: 'vehicleIdentificationNumbers',
    value: 'Vehicle identification number',
    chipProps: {
      show: true,
      label: 'VehicleCleanDirt.vehicleIdentificationNumbers',
    },
    calendarProps: {
      show: false,
    },
    inputProps: {
      show: true,
      id: 'VehicleCleanDirt-dates-vehicleIdentificationNumbers',
      key: 'VehicleCleanDirt-dates-vehicleIdentificationNumbers',
      label: 'VehicleCleanDirt.vehicleIdentificationNumbers',
      charLimit: 40,
    },
    inputPropsTime: {
      show: false,
    },
    additionalInputProps: {
      show: false,
    },
    drowpdownProps: {
      show: false,
    },
  },
  shiftNumbers: {
    key: 'shiftNumbers',
    value: 'Shift-number',
    chipProps: {
      show: true,
      label: 'VehicleCleanDirt.shiftNumbers',
    },
    calendarProps: {
      show: false,
    },
    inputProps: {
      show: true,
      id: 'VehicleCleanDirt-shiftNumbers',
      key: 'VehicleCleanDirt-shiftNumbers',
      label: 'VehicleCleanDirt.shiftNumbers',
      charLimit: 40,
    },
    inputPropsTime: {
      show: false,
    },
    additionalInputProps: {
      show: false,
    },
    drowpdownProps: {
      show: false,
    },
  },
  productionNumbers: {
    key: 'productionNumbers',
    value: 'Production Number',
    chipProps: {
      show: true,
      label: 'VehicleCleanDirt.productionNumbers',
    },
    calendarProps: {
      show: false,
    },
    inputProps: {
      show: true,
      id: 'VehicleCleanDirt-productionNumbers',
      key: 'VehicleCleanDirt-productionNumbers',
      label: 'VehicleCleanDirt.productionNumbers',
      charLimit: 40,
    },
    inputPropsTime: {
      show: false,
    },
    additionalInputProps: {
      show: false,
    },
    drowpdownProps: {
      show: false,
    },
  },
  otherDescriptions: {
    key: 'otherDescriptions',
    value: 'Other description',
    chipProps: {
      show: true,
      label: 'VehicleCleanDirt.otherDescriptions',
    },
    calendarProps: {
      show: false,
    },
    inputProps: {
      show: true,
      id: 'VehicleCleanDirt-otherDescriptions',
      key: 'VehicleCleanDirt-otherDescriptions',
      label: 'VehicleCleanDirt.otherDescriptions',
      fullWidth: true,
      charLimit: 256,
    },
    inputPropsTime: {
      show: false,
    },
    additionalInputProps: {
      show: false,
    },
    drowpdownProps: {
      show: false,
    },
  },
  releases: {
    key: 'releases',
    value: 'Releases',
    chipProps: {
      show: true,
      label: 'affectedVehicles.summary.newRelease',
    },
    calendarProps: {
      show: false,
    },
    inputProps: {
      show: true,
      id: 'VehicleCleanDirt-releaseName',
      key: 'releaseName',
      label: 'affectedVehicles.summary.releaseName',
      isOptional: true,
      fullWidth: false,
      charLimit: 64,
    },
    inputPropsTime: {
      show: false,
    },
    additionalInputProps: {
      show: true,
      id: 'VehicleCleanDirt-additionalInfo',
      key: 'additionalInfo',
      label: 'affectedVehicles.summary.additionalInfo',
      isOptional: true,
      fullWidth: true,
      charLimit: 1024,
    },
    drowpdownProps: {
      show: false,
    },
  },
};

export const VEHICLESNOK_DATA = {
  ...VEHICLESOK_DATA,
  fromStartOfProductions: {
    key: 'fromStartOfProductions',
    value: 'From Start of production',
    chipProps: {
      show: true,
      label: 'VehicleCleanDirt.fromStartOfProductions',
    },
    calendarProps: {
      show: false,
    },
    inputProps: {
      show: false,
    },
    inputPropsTime: {
      show: false,
    },
    additionalInputProps: {
      show: false,
    },
    drowpdownProps: {
      show: false,
    },
  },
  releases: {
    key: 'releases',
    value: 'Releases',
    chipProps: {
      show: true,
      label: 'affectedVehicles.summary.oldRelease',
    },
    calendarProps: {
      show: false,
    },
    inputProps: {
      show: true,
      id: 'VehicleCleanDirt-releaseName',
      key: 'releaseName',
      label: 'affectedVehicles.summary.releaseName',
      isOptional: true,
      fullWidth: false,
      charLimit: 64,
    },
    inputPropsTime: {
      show: false,
    },
    additionalInputProps: {
      show: true,
      id: 'VehicleCleanDirt-additionalInfo',
      key: 'additionalInfo',
      label: 'affectedVehicles.summary.additionalInfo',
      isOptional: true,
      fullWidth: true,
      charLimit: 1024,
    },
    drowpdownProps: {
      show: true,
      id: 'VehicleCleanDirt-moreUpcomingReleases',
      key: 'moreUpcomingReleases',
      label: 'affectedVehicles.summary.moreUpcomingReleases',
      form: formYESNO,
    },
  },
};

export const OPTIONS_MENU = {
  dirtPoint: VEHICLESNOK_DATA,
  cleanPoint: VEHICLESOK_DATA,
};

const OKRequestMenu = {
  dates: {
    key: 'Date',
    label: 'affectedVehicles.summary.dates',
  },
  vehicleIdentificationNumbers: {
    key: 'Vehicle identification number',
    label: 'affectedVehicles.summary.vehicleIdentificationNumbers',
  },
  shiftNumbers: {
    key: 'Shift-number',
    label: 'affectedVehicles.summary.shiftNumbers',
  },
  productionNumbers: {
    key: 'Production Number',
    label: 'affectedVehicles.summary.productionNumbers',
  },
  ttzs: {
    key: 'TTZ',
    label: 'affectedVehicles.summary.ttzs',
  },
  otherDescriptions: {
    key: 'Other description',
    label: 'affectedVehicles.summary.otherDescriptions',
  },
  releases: {
    key: 'Releases',
    label: 'affectedVehicles.summary.release',
  },
};

export const MENU = {
  NOKRequest: [
    {
      fromStartOfProductions: {
        key: 'From Start of production',
        label: 'affectedVehicles.summary.fromStartOfProductions',
      },
      ...OKRequestMenu,
    },
  ],
  OKRequest: [OKRequestMenu],
};
